import * as React from 'react';
import './index.scss';
import Navbar from '@roo/roo-plus/Navbar';
import Menu, { MenuItem, SubMenu } from '@roo/roo-plus/Menu';
import { connect } from 'react-redux';
import { Switch, Link, useHistory } from 'react-router-dom';
import { Loading } from '@roo/roo';
import Marquee from 'react-fast-marquee';
import {
    menus as unGrayMenu,
    getMatchLinkList,
    MENUS_CONFIG,
    iconBackupList,
    getResources,
    commonGrayMenus,
    creatorMenus,
} from '../../config';
import { IServerResponse } from '@/utils/request';
import urlUtil, { isCreator, isOutCustomerService, isMenuGray } from '@/utils/url';
import useUnreplyCount from '@/hooks/use-unreply-count';
import useUnreadCount from '@/hooks/use-unread-count';

import {
    getSignStateList,
    getProtocolStatus,
    getMessageUnread,
    getDynamicMenu,
    getDXLoginUrl,
    IAccountRes,
    PROTOCOL_STATUS,
    getNoticeList,
    IAnnouncement,
} from '@/services';

const { Suspense, useState, useEffect } = React;
const message = isMenuGray ? 'messageCenter' : 'message';

const getDefautSelect = (menu: MENUS_CONFIG[]): string | number => {
    const { hash } = window.location;
    if (hash === '#/' && menu != null && menu.length !== 0 && menu[0].link) {
        window.location.hash = menu[0].link;
    }
    const matchLinkList = getMatchLinkList(menu);
    const matchItem = matchLinkList.find(({ link }) => {
        if (Array.isArray(link)) {
            return link.find(v => hash.includes(v));
        }
        return hash.includes(link);
    });
    if (matchItem) {
        return matchItem.id;
    }
    return 'manage';
};

const MenuItemRender = ({ item }: any) => (
    <Link to={item.link}>
        <MenuItem className="pro-menu-item" id={item.id}>
            {item.iconUrl ? (
                <img style={{ width: '19px' }} src={item.iconUrl} />
            ) : (
                <i className={`iconfont icon-${item.icon}`} />
            )}
            <span>
                {item.name}
                {/* 防止返回一个字符串型的"0" */}
                {!Number(item.unreadNumber) ? null : (
                    <span className="badge-tag" id={item.id === message ? 'messageUnreadNum' : ''}>
                        {item.unreadNumber > 99 ? '99+' : item.unreadNumber}
                    </span>
                )}
            </span>
        </MenuItem>
    </Link>
);

interface IProps {
    children: React.ReactElement | React.ReactElement[];
    userData: IAccountRes;
    setProviderData: (data: IAccountRes) => void;
}

function Layout(props: IProps) {
    const history = useHistory();
    let defaultOpenedIds: [string | number] | undefined;
    const [isAgree, setIsAgree] = useState<boolean>(false);
    const [loginSessionUrl, setLoginSessionUrl] = useState<string>('');
    const [menus, setMenus] = useState<MENUS_CONFIG[]>(isMenuGray ? [] : unGrayMenu);
    const isProvider = !urlUtil.commonParams.providerRole;
    const title = <span className="pro-title">服务商管理系统</span>;
    const { data: unreplyCount } = useUnreplyCount();
    const { data: unreadConnt } = useUnreadCount();
    const [collapsed, setCollapsed] = useState(true);
    const [mouseOvering, setMouseOvering] = useState(false);
    const defaultSelect = getDefautSelect(menus);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [messageList, setMessageList] = useState<IAnnouncement[]>([]);
    const [showMessageCenter, setShowMessageCenter] = useState(false);
    const [showEvaluation, setShowEvaluation] = useState(false);

    if (defaultSelect === 'settlement_service' || defaultSelect === 'settlement_thirdpartnar') {
        defaultOpenedIds = ['settlement'];
    }

    const getGrayDynamic = async (_menus, resources) => {
        const dynamicMent = await getDynamicMenu();
        const insertList: MENUS_CONFIG[] = dynamicMent.data
            .filter(({ menuCode }) => resources.some(__menu => __menu === menuCode)) // 检查 id 是否不在 _menus 中
            .map(({ id, name, url }) => ({
                id,
                name,
                link: `/main/v3/poster/${id}?url=${encodeURIComponent(url)}`,
                icon: iconBackupList.shift(),
            }));

        _menus.splice(1, 0, ...insertList);
        setMenus(_menus);
    };

    const judgeMessageCenter = (_menus: MENUS_CONFIG[], type: string) =>
        _menus.some(item => item.id === type);

    // 递归过滤函数
    function filterChildren(_menu: MENUS_CONFIG, menuList: string[]): MENUS_CONFIG | null {
        if (_menu.children) {
            _menu.children = _menu.children
                .map(child => filterChildren(child, menuList))
                .filter(child => child !== null) as MENUS_CONFIG[];
        }
        return menuList.includes(_menu.id.toString()) ||
            (_menu.children && _menu.children.length > 0)
            ? _menu
            : null;
    }

    const getGrayMenuList = async () => {
        if (isCreator) {
            setMenus(creatorMenus);
            return;
        }
        const resources = await getResources();
        const _menus: MENUS_CONFIG[] = [];
        commonGrayMenus.forEach(item => {
            const filteredItem = filterChildren(item, resources);
            if (filteredItem) {
                _menus.push(filteredItem);
            }
        });
        getGrayDynamic(_menus, resources);
        setShowMessageCenter(judgeMessageCenter(_menus, 'messageCenter'));
        setShowEvaluation(judgeMessageCenter(_menus, 'evaluation'));
    };

    useEffect(() => {
        if (isMenuGray) {
            getGrayMenuList();
        }
    }, []);

    function loginSession() {
        window.open(loginSessionUrl);
    }

    function logout() {
        window.location.href = '/logout/';
    }

    const right = (
        <div className="user">
            <div className="user-main">
                <p>{props.userData.serviceProviderName}</p>
                <i className="iconfont icon-wmb-pc-down-arrow" />
            </div>
            <div className="user-dropdown">
                {isProvider && isAgree && (
                    <div
                        className="ndropdown-item"
                        onClick={() => {
                            history.push('/account');
                        }}
                    >
                        账号设置
                    </div>
                )}
                {!isCreator && (
                    <>
                        <div className="ndropdown-line" />
                        <div className="ndropdown-item" onClick={loginSession}>
                            登录客服
                        </div>
                    </>
                )}
                <div className="ndropdown-line" />
                <div className="ndropdown-item" onClick={logout}>
                    退出登录
                </div>
            </div>
        </div>
    );

    // 公告栏
    const left = (
        <>
            <div>{title}</div>
            <div style={{ flex: 1 }}>
                <div style={{ width: '60%', margin: '0 20%' }}>
                    <Marquee pauseOnHover pauseOnClick speed={25}>
                        {messageList.map(i => (
                            <div style={{ width: '100%', textAlign: 'right' }}>
                                <a
                                    href={`/#/messageContent?id=${i.id}`}
                                    style={{ color: '#f89800' }}
                                >
                                    {i.title}
                                </a>
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </>
    );

    useEffect(() => {
        getSignStateList().then(res => {
            const { data } = res;
            props.setProviderData(data);
        });

        getProtocolStatus().then(res => {
            if (res.data.isAgree !== PROTOCOL_STATUS.unAgree) {
                setIsAgree(true);
            }
        });

        getDXLoginUrl().then((res: IServerResponse<string>) => {
            setLoginSessionUrl(res.data);
        });

        function fetchMessageUnread() {
            return getMessageUnread()
                .then(res => res.data || 0)
                .catch(() => 0);
        }

        // 灰度控制更新菜单未读消息气泡
        if (isMenuGray) {
            // 灰度更新菜单未读消息气泡
            if (showEvaluation || showMessageCenter) {
                fetchMessageUnread()
                    .then(messageUnreadData => {
                        const __menus = handleUnreadData(message, messageUnreadData, menus);
                        setMenus(__menus);
                    })
                    .catch(() => {});
            }
        } else {
            if (!isCreator) {
                fetchMessageUnread()
                    .then(messageUnreadData => {
                        const __menus = handleUnreadData('message', messageUnreadData, menus);
                        setMenus(__menus);
                    })
                    .catch(() => {});

                if (!isOutCustomerService) {
                    getDynamicMenu()
                        .then(dynamicMenuRes => {
                            const __menus = menus;
                            /**
                             * 改版之后由于之前后端配置的icon为img图片，和新的导航组件样式不匹配，所以和产品讨论后决定使用icon解决
                             * 方案为：iconBackupList 中有4个icon，只要配置小于等于4个可以满足需求，不满足的情况下，还需要自行添加
                             */
                            const insertList: MENUS_CONFIG[] = dynamicMenuRes.data.map(
                                ({ id, name, url }) => ({
                                    id,
                                    name,
                                    link: `/main/v3/poster/${id}?url=${encodeURIComponent(url)}`,
                                    icon: iconBackupList.shift(),
                                }),
                            );
                            __menus.splice(1, 0, ...insertList);
                            setMenus(__menus);
                        })
                        .catch(() => {});
                }
            }
        }

        function handleUnreadData(itemId: string, n: number, _menus1: MENUS_CONFIG[]) {
            const __menus = _menus1.slice(0);
            const i = __menus.findIndex(item => item.id === itemId);
            __menus[i].unreadNumber = n;
            return __menus;
        }

        updateNoticeList();
        // 轮询请求接口
        setInterval(() => {
            const now = new Date();
            // console.log('当前时间', now.getMinutes(), now.getSeconds());
            if (now.getMinutes() === 0 && now.getSeconds() === 0) {
                // 整点请求
                updateNoticeList();
            }
        }, 1000);
    }, []);

    // 获取公告信息
    const updateNoticeList = () => {
        getNoticeList().then(res => {
            // 判断是否需要更新
            const oldStr = messageList.map(i => i.id).join('');
            const newStr = res.data.map(i => i.id).join('');
            if (oldStr !== newStr) {
                setMessageList(res.data);
            }
        });
    };

    useEffect(() => {
        checkAndChangeCollapsed();

        window.addEventListener('resize', checkAndChangeCollapsed);
        function checkAndChangeCollapsed() {
            // 屏幕大小小于1145则左侧菜单展示缩略图
            const wwidth = window.document.documentElement.clientWidth;
            if ((wwidth >= 1145 && collapsed) || (wwidth < 1145 && !collapsed)) {
                setCollapsed(!collapsed);
            }
        }
        return () => window.removeEventListener('resize', checkAndChangeCollapsed);
    }, [collapsed]);

    // 评价管理未读气泡
    useEffect(() => {
        if (isMenuGray) {
            if (!showEvaluation) return;
        } else {
            if (isCreator) return;
        }
        setMenus(prevMenus => {
            const i = prevMenus.findIndex(item => item.id === 'evaluation');
            const nextMenus = [...prevMenus];
            if (nextMenus[i]) {
                nextMenus[i].unreadNumber = unreplyCount;
            }
            return nextMenus;
        });
    }, [unreplyCount, menus.length]);

    // 消息中心未读气泡
    useEffect(() => {
        if (isMenuGray) {
            if (!showMessageCenter) return;
        } else {
            if (isCreator) return;
        }
        setMenus(prevMenus => {
            const i = prevMenus.findIndex(item => item.id === message);
            const nextMenus = [...prevMenus];
            if (nextMenus[i]) {
                nextMenus[i].unreadNumber = unreadConnt;
            }
            return nextMenus;
        });
    }, [unreadConnt, menus.length]);

    const handleMouseOver = () => {
        if (!mouseOvering) {
            setMouseOvering(true);
        }
    };
    const handleMouseLeave = () => {
        if (mouseOvering) {
            setMouseOvering(false);
        }
    };
    return (
        <div className="pro-body">
            <Navbar
                className="pro-header"
                theme="dark"
                right={right}
                // title={title}
                left={left}
            />
            <div className="pro-main">
                <div
                    className="pro-left"
                    onMouseOver={handleMouseOver}
                    onMouseLeave={handleMouseLeave}
                >
                    <Menu
                        selectedIds={[defaultSelect]}
                        defaultOpenedIds={defaultOpenedIds}
                        collapsed={collapsed && !mouseOvering}
                        theme="light"
                        className="pro-menu"
                    >
                        {menus.map(item =>
                            item.children ? (
                                <SubMenu
                                    key={item.id}
                                    id={item.id}
                                    title={
                                        <span>
                                            {item.iconUrl ? (
                                                <img alt="" src={item.iconUrl} />
                                            ) : (
                                                <i className={`iconfont icon-${item.icon}`} />
                                            )}

                                            <span>
                                                {collapsed && !mouseOvering ? '' : item.name}
                                            </span>
                                        </span>
                                    }
                                >
                                    {item.children.map(_item => (
                                        <MenuItemRender key={_item.id} item={_item} />
                                    ))}
                                </SubMenu>
                            ) : (
                                <MenuItemRender key={item.id} item={item} />
                            ),
                        )}
                    </Menu>
                </div>
                <div className="pro-right">
                    <Suspense
                        fallback={
                            <Loading text="正在加载...">
                                <p style={{ height: '500px' }} />
                            </Loading>
                        }
                    >
                        <Switch>{props.children}</Switch>
                    </Suspense>
                </div>
            </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch: any) => ({
    setProviderData: (data: any) => {
        const type = 'provider/update';
        return dispatch({
            type,
            payload: {
                user: data,
            },
        });
    },
});

const mapStateToProps = (state: any) => ({
    userData: state.provider.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
